<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="100vw"
      fullscreen
    >
      <div class="modal-zoom">
        <v-card>
          <v-card-text>
            <div
              v-if="parseInt(modals.file.categories, 10) === 1"
              class="flag-container"
            >
              <div class="flag">
                Draft
              </div>
            </div>
            <div v-if="!modals.file.view_type">
              <img
                v-if="isImage(selectedZoomUrl)"
                :src="selectedZoomUrl"
                :class="`rotate_images__position_${selectedZoomRotatePosition}`"
                @error="onImgError(selectedZoomUrl)"
              />
              <video
                v-else-if="isVideo(selectedZoomUrl)"
                width="100%"
                height="100%"
                controls
              >
                <source
                  :src="selectedZoomUrl"
                  :type="getVideoType(selectedZoomUrl)"
                >
                Your browser does not support the video tag.
              </video>
            </div>
            <iframe
              v-else
              id="inner_iframe"
              src="/books/comic-book-v2/?v=8"
              class="iframe-modal"
              title="Comic"
              frameborder="0"
              allowtransparency="true"
            ></iframe>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-muted text-center mx-auto">
              <small>{{ modals.file.name }} - {{ formatDate(modals.file.created_at) }}</small>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="$emit('closingModal', false)"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ['modals'],
  computed: {
    selectedZoomIndex() {
      const idx = Number.parseInt(this.modals.file.zoomIndex, 10)
      return Number.isInteger(idx) && idx >= 0 ? idx : 0
    },
    selectedZoomUrl() {
      if (this.modals.file.zoomUrl) return this.modals.file.zoomUrl
      const relatedFiles = this.modals.file.related_files || []
      return relatedFiles[this.selectedZoomIndex] || relatedFiles[0] || ''
    },
    selectedZoomRotatePosition() {
      const rotatePositions = this.modals.file.rotate_position || []
      return rotatePositions[this.selectedZoomIndex] || rotatePositions[0] || 0
    },
  },
  data() {
    return {
      dialog: true,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',	'July',	'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      endpoint: process.env.VUE_APP_ROOT_API,
      failedImages: {},
      scrollLockState: null,
    }
  },
  mounted() {
    this.lockBackgroundScroll()
    if (this.modals.file.view_type) {
      this.callIframe()
    }
  },
  beforeDestroy() {
    this.unlockBackgroundScroll()
  },
  methods: {
    lockBackgroundScroll() {
      const appElement = document.getElementById('app')

      this.scrollLockState = {
        bodyOverflow: document.body.style.overflow,
        documentOverflow: document.documentElement.style.overflow,
        appOverflow: appElement ? appElement.style.overflow : '',
      }

      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
      if (appElement) {
        appElement.style.overflow = 'hidden'
      }
    },
    unlockBackgroundScroll() {
      if (!this.scrollLockState) return

      const appElement = document.getElementById('app')

      document.body.style.overflow = this.scrollLockState.bodyOverflow
      document.documentElement.style.overflow = this.scrollLockState.documentOverflow
      if (appElement) {
        appElement.style.overflow = this.scrollLockState.appOverflow
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    getVideoType(filePath) {
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    callIframe() {
      const iframe = document.getElementById('inner_iframe')
      const self = this
      let iWindow = null
      iframe.addEventListener('load', () => {
        iWindow = iframe.contentWindow
        if (iWindow === null) {
          self.callIframe()
        }
        iWindow.postMessage(['book-infos', { related_files: this.modals.file.related_files, rotate_position: this.modals.file.rotate_position }])
      })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${this.months[parseInt(month, 10) - 1]} ${day} ${year}`
    },
  },
}
</script>

<style scoped lang="scss">
  .modal-zoom {
    height: 100vh;
    overflow: hidden;

    .v-card {
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .v-card__actions {
      flex: 0 0 auto;
    }
  }

  .theme--light.v-card {
    background: #000;
    color: #fff !important
  }
  .v-card__text {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    overflow-x: hidden;

    @media(max-width: 940px) {
      height: 100vh;
    }

    img {
      height: auto;
      border-radius: 12px;
      width: auto;
      margin: 0 auto;
      display: block;
      max-width: 100%;
      object-fit: contain;
    }

    .iframe-modal {
      width: 75vw;
      height: 88vh;

      // @include below(769px) {
      //   width: 98vw;
      //   height: 85vh;
      // }
    }
  }

  .v-dialog {
    .v-divider + .v-card__actions {
      background: #000 !important;
    }
  }

</style>
